/*--------------------------------------------> global.js <--------------------------------------------*/
console.log("Global.js");
/*------ Sort Swatch ------*/
function sortSwatch() {
  $(".swatch-buttons").each(function() {
    // Sorting Swatches by Alphabetically (Color Name)
    let alphabeticallyOrderedDivs = $(this).find('button.swatch-btn').sort(function(a, b) {
      return String.prototype.localeCompare.call($(a).data('original-title').toLowerCase(), $(b).data('original-title').toLowerCase());
    });
    $(this).append(alphabeticallyOrderedDivs);
  })
}

window.initHoverLine = function (selector,opts) {
  $(selector).each(function () {
    var $this = $(this);
    if (!$this.hasClass('cc-init')) {
      var updateLine = function updateLine() {
        var $link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $this.find('li a[aria-selected="true"], li a.active');
        if ($link.length === 1) {
          $hoverLine.css({
            width: $link.width(),
            top: $link.position().top + $link.outerHeight(),
            left: $link.position().left
          });
        }
      };

      $this.append("<li class='cc-hover-line'></li>").addClass('cc-init');
      var $hoverLine = $(this).find(".cc-hover-line");

      if (opts && opts.lineCss) {
        $hoverLine.css(opts.lineCss);
      }

      updateLine();
      $(this).find("li").hover(function () {
        var $link = $(this).find('a');

        if ($link.length === 1) {
          updateLine($link);
        }
      }, function () {
        updateLine();
      });
      $(window).on('debouncedresizewidth', function () {
        updateLine();
      });
    }
  });
};

/*------ Get Product Block Swatch ------*/
async function GetCollectionSwatch(handle, productId, isFirst) {
  fetch(`/products/${handle}.js`)
  .then(response => response.text())
  .then(async function(response){
    if(response == "" ) return;
   
    let SyncProduct = await JSON.parse(response);
    if(SyncProduct.available ){
      let syncProductTags = SyncProduct.tags;
      let colorName = syncProductTags.find(tag => tag.includes("_color_")) ?? syncProductTags.find(tag => tag.includes("color_"));
      let swatchColorName = "";
      let altText = "";
      colorName ? swatchColorName = (colorName.split("color_"))[1] : swatchColorName = "";
      if (colorName) {
        if (colorName.includes("_color_")) {
          altText = (colorName.split("_color_"))[0];
        } else {
          altText = (colorName.split("color_"))[1];
        }
      }
      swatchColorName = swatchColorName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ', '-');
      let img_url = `https://cdn.shopify.com/s/files/1/0517/2451/7546/files/${swatchColorName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ','-')}.png?v=1638888127`;
      let isActive = "";
      isFirst ? isActive = "swatch-active" : isActive = "";
      let swatchHTML =
          `<button type="button" data-price="${SyncProduct.price}" data-compare-price="${SyncProduct.compare_at_price}" data-trigger="hover" data-toggle="tooltip" data-placement="top" title="${altText.toUpperCase()}" data-title ="${SyncProduct.handle}" data-swatch-name="${swatchColorName}" class="swatch-btn swatch-btn-image ${isActive}">
          	<img class="swatch-image lazyload" data-src="${img_url}"  src="${img_url}"/>
          	<noscript class="product-json" type="application/json">${response}<\/noscript>
          </button>`;
      document.querySelector(`.swatch-buttons.swatch_for_${productId}`).insertAdjacentHTML("beforeEnd", swatchHTML)
      let tooltipTriggerList = [].slice.call(document.querySelector(`.collection-swatch.swatch_for_${productId}`).querySelectorAll('[data-toggle="tooltip"]'))
      let tooltipList = tooltipTriggerList.map(function(tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
      });
    }
    sortSwatch();

  })
  // .then(async function(response) {
  // //  console.log(typeof response.status)
  //  if(response.status === 404){
  //    return;
  //  }
  // })
.catch((error) => {
  console.warn(error)
});
}

/*------ Get Swatches On Product Page ------*/
function GetProductPageSwatch(handle,productId,isFirst, forType){
  fetch(`/products/${handle}.js`)
  .then(response => response.text())
  .then((response) => {
    let SyncProduct = JSON.parse(response);
    let syncProductTags = SyncProduct.tags;
    if(forType == "color"){
      let colorName = syncProductTags.find(tag =>tag.includes("_color_")) ?? syncProductTags.find(tag =>tag.includes("color_"));
      let swatchColorName = "";
      let altText = "";
      //       console.log(colorName)
      colorName ? swatchColorName = (colorName.split("color_"))[1] : swatchColorName = ""; 
      if(colorName){
        if(colorName.includes("_color_")){
          altText = (colorName.split("_color_"))[0];
        }else{
          altText = (colorName.split("color_"))[1];
        }
      }

      //       console.log("alt Text ",swatchColorName, altText);

      swatchColorName = swatchColorName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ','-');

      let img_url = `https://cdn.shopify.com/s/files/1/0517/2451/7546/files/${swatchColorName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ','-')}.png?v=1638888127`;
      let isActive = "";
      let hasUrl = "";
      isFirst ? isActive = "swatch-active" : isActive = "";
      !isFirst ? hasUrl = `/products/${SyncProduct.handle}` : hasUrl = "javascript:void(0);";

      let swatchHTML = 
          `<a href="${hasUrl}"  data-trigger="hover" data-toggle="tooltip" data-placement="top" title="${altText.toUpperCase()}" data-title ="${SyncProduct.handle}" class="swatch-btn swatch-btn-image ${isActive}">
            <img class="swatch-image lazyload" data-src="${img_url}"  src="${img_url}"/>
            <noscript class="product-json" type="application/json">${response}<\/noscript>
           </a>`;
      document.querySelector(`.product-swatch.swatch_for_${productId}`).insertAdjacentHTML("beforeEnd",swatchHTML)

      var tooltipTriggerList = [].slice.call(document.querySelector(`.product-swatch.swatch_for_${productId}`).querySelectorAll('[data-toggle="tooltip"]'))
      var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {    
        return new bootstrap.Tooltip(tooltipTriggerEl)    
      });

      // Sorting Swatches by Alphabetically (Color Name)
      $(".product-swatch").each(function(){
        var alphabeticallyOrderedDivs = $(this).find('a.swatch-btn').sort(function(a, b) {
          return String.prototype.localeCompare.call($(a).data('original-title').toLowerCase(), $(b).data('original-title').toLowerCase());
        });
        $(this).append(alphabeticallyOrderedDivs);
        //$(this).addClass("sorted");
      });
    }
    else if(forType == "altura"){
      console.log(handle,productId,isFirst, forType);
      let currentProductHeight = syncProductTags.find(tag =>tag.includes("height_")) ?? "";
      if(!currentProductHeight.length) return;
      if(currentProductHeight.length > 0){
        currentProductHeight = currentProductHeight.split("height_")[1];
        let isActive;
        isFirst ? isActive = "active" : isActive = "variant-sold-out";

        let hasUrl = "";
        !isFirst ? hasUrl = `/products/${SyncProduct.handle}` : hasUrl = "javascript:void(0);";
        let alturaHtml = `<li> <a href="${hasUrl}" class="${isActive}" data-value="${currentProductHeight}">${currentProductHeight}</a></li>`;
        document.querySelector(`.product-altura-list.altura_for_${productId}`).querySelector(".clickyboxes").insertAdjacentHTML("beforeEnd",alturaHtml);
      } 
    }
    else{
      return;
    } 
    $(".product-altura-list li:not(.cc-hover-line)").sort(function(a, b) {
      if(a.textContent.length > b.textContent.length || a.textContent > b.textContent){
        return 1	
      }else{
        return -1;
      }

    }).appendTo('.product-altura-list .clickyboxes.altura');
  })
  .catch((err)=>{
    console.warn(err)
  });
}

if(theme.settings.cartDrawerEnable){
  var _learnq = _learnq || [];
  function addedToCart() {
    fetch(`${window.location.origin}/cart.js`)
    .then(res => res.clone().json().then(data => {
      var cart = {
        total_price: data.total_price/100,
        $value: data.total_price/100,
        total_discount: data.total_discount,
        original_total_price: data.original_total_price/100,
        items: data.items
      }
      if (item !== 'undefined') {
        cart = Object.assign(cart, item)
      }
      _learnq.push(['track', 'Added to Cart', cart])
    }))
  }
  (function (ns, fetch) {
    ns.fetch = function() {
      const response = fetch.apply(this, arguments);
      response.then(res => {
        if (`${window.location.origin}/cart/add.js`
          .includes(res.url)) {
              addedToCart()
        }
      });
      return response
    }
  }(window, window.fetch));
  
  theme.CartDrawer = (function(){
    const selectors = {
      cartOpener: ".cart-drawer-toggle",
      cartDrawer: "#added-to-cart",
      initalCart: "[data-ajax-cart-initial-state]",
      removeItem: "[data-remove-item]",
      decreaseItem: "[data-decrease]",
      increaseItem: "[data-increase]",
      quantityContainer: ".quantity",
      checkoutBtn: "#cart__submit_btn",
      cartCloser: ".modal-close[data-modal-close]",
      cartLoader: ".loader-cover",
      cartItem: ".cart-product__content",
    };

    function CartDrawer(){
      this.cartJson = JSON.parse(document.querySelector(selectors.initalCart).innerText);
      this.cartCount = this.cartJson.item_count;
      this._isLoading = false;
      this._bindEvents();
    }

    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      _bindEvents: function(){
        document.querySelector(selectors.cartOpener).addEventListener("click",this._openCart);
        document.querySelector(selectors.cartCloser).addEventListener("click", this._closeCart);
        document.querySelector(selectors.cartLoader).style.display = "none";
        this._attachEventListeners();
      },

      _updateCount: function(){
        this.cartJson = JSON.parse(document.querySelector(selectors.initalCart).innerText);
        this.cartCount = parseInt(this.cartJson.item_count);
        if(this.cartCount > 0){
           document.querySelectorAll(".js-cart-count").forEach((countBubble)=>{
            countBubble.innerHTML = `${this.cartJson.item_count}`;
            countBubble.classList.add("show");
          });
          document.querySelector(selectors.cartOpener).querySelector(".text-link").innerHTML = `${window.theme.strings.cartText} (${this.cartJson.item_count})`;	
        }else{
           document.querySelectorAll(".js-cart-count").forEach((countBubble)=>{
            countBubble.innerHTML = `${this.cartJson.item_count}`;
            countBubble.classList.remove("show");
          });
          document.querySelector(selectors.cartOpener).querySelector(".text-link").innerHTML = `${window.theme.strings.cartText}`;
        }
      },

      _attachEventListeners: function(){        
        document.querySelectorAll(selectors.removeItem).forEach((element)=>{
          element.addEventListener("click",this._removeItem.bind(this));
        });
        document.querySelectorAll(selectors.decreaseItem).forEach((element)=>{
          element.addEventListener("click",this._updateQty.bind(this));
        });
        document.querySelectorAll(selectors.increaseItem).forEach((element)=>{
          element.addEventListener("click",this._updateQty.bind(this));
        });
        document.querySelector(selectors.checkoutBtn)?.addEventListener("click", (_)=>{
        //           let hasAgreedTerms = document.querySelector("#cart_agree").checked;
          // window.location.href = "/checkout?locale=" + ((window.Weglot && Weglot.getCurrentLang()) || "en");
          window.location.href = "/checkout?locale=" + ((window.langify.locale.iso_code) || "en");
        });
        document.querySelector("#cart_agree")?.addEventListener("change", function(e){
          if(this.checked){
        	document.querySelector(".under-cart").querySelector(".check_tooltip").style.display = "none";
          }
        });
      },

      _refreshCart:function(variant){
         document.querySelector(selectors.cartLoader).style.display = "block";
        var _this = this;
        fetch(`/cart?view=drawer-ajax`, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            "Content-type": "application/html; charset=UTF-8",
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.text())
        .then(function(data) {
          let parser = new DOMParser();
          let content = parser.parseFromString(data,"text/html");
          document.querySelector(selectors.cartDrawer).innerHTML = content.querySelector(selectors.cartDrawer).innerHTML;
          document.querySelector(selectors.initalCart).innerHTML = content.querySelector(selectors.initalCart).innerHTML;
          _this._updateCount();
          setTimeout(function(){
            _this._attachEventListeners();
          },500);
        })
        .catch(err=>console.error(err));

      },

      _updateItem: async function(item){
        var _this = this;
        fetch(`${window.theme.routes.cart_change_url}.js`, {
          method: 'POST',
          body: JSON.stringify(item),
          credentials: 'same-origin',
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          console.log(data);
          _this._refreshCart();
          _this._isLoading = false;
        }.bind(this))
        .catch(err=>console.error(err));
      },

      _removeItem: function(e){
        this._isLoading = true;
        var _this = this;
        let itemKey = e.target.getAttribute("data-item-key");
        let item = { id: itemKey, quantity: 0 };
        this._updateItem(item);        
      },

      _updateQty: function(e){
        let quantity;
        if( this.errorTimeout) clearTimeout(this.errorTimeout);
        let itemKey = e.currentTarget.getAttribute("data-item-key");
        let originalQuantity =  Number(e.target.closest(selectors.quantityContainer).querySelector(".item-quantity").value);
        let inventoryQuantity = Number(e.target.closest(selectors.quantityContainer).querySelector(".item-quantity").getAttribute("data-inventory"))
        let productTitle = e.target.closest(selectors.cartItem).querySelector(".cart-product__content__title").textContent;
        document.querySelector(".cart-drawer-items").querySelectorAll(".product-status-message").forEach((element)=>{
          element.remove();
        });
        
        if(e.currentTarget.classList.contains("plus")){
          quantity = originalQuantity + 1;
          let errorMessage = `<div class="product-status-message" style="display: block;">TU CARRITO CONTIENE: ${quantity} ${productTitle}.</div>`;
          if(originalQuantity == inventoryQuantity){
            e.target.closest(selectors.cartItem).insertAdjacentHTML("beforeend", errorMessage);
            this.errorTimeout =  setTimeout(function(){
              document.querySelector(".cart-drawer-items").querySelectorAll(".product-status-message").forEach((element)=>{
                element.remove();
              });	
            },2500);

            return;
          } 
          
        }else{
          quantity = originalQuantity - 1;
        }
        if(quantity == undefined || itemKey == undefined) return;
        
        if(quantity < 0 ) quantity = 0;
        
        
        
        let item = { id: itemKey, quantity: quantity};
        this._updateItem(item);
      },

      _openCart: function(e){
        let offset = 25;
        let nav = theme.Nav();

        if (nav.bar.getPositionSetting() !== "inline") {
          offset = nav.bar.height();
        }
        //         console.log(document.querySelector(selectors.cartDrawer));
        document.querySelector(selectors.cartDrawer).classList.remove("unreveal");
        document.querySelector(selectors.cartDrawer).classList.add("reveal");
        document.querySelector("body").classList.add("overflow_cart");
        
        setInterval(function(){
          //document.querySelector(selectors.cartDrawer).querySelector(".inner").style.top = `${offset}px`;
          document.querySelector(selectors.cartDrawer).querySelector(".inner").style.top = `offset`;
          
        });
        
      },
        
      _closeCart: function(e){
        document.querySelector(selectors.cartDrawer).classList.remove("reveal");
        document.querySelector(selectors.cartDrawer).classList.add("unreveal");
        document.querySelector("body").classList.remove("overflow_cart");
      }

    });

    return CartDrawer;

  })();  
}

window.addEventListener("load", (_)=>{
    $(document).ajaxComplete(function(event, request, settings){
      if(settings.url == "/cart/add.js"){
          addedToCart()
      }
    });
    $(".product-altura-list li:not(.cc-hover-line)").sort(function(a, b) {
      if(a.textContent.length > b.textContent.length || a.textContent > b.textContent){
        return 1	
      }else{
        return -1;
      }

    }).appendTo('.product-altura-list .clickyboxes.altura');

    

    if(theme.settings.cartDrawerEnable) new theme.CartDrawer();
    document.querySelector("#cart_agree")?.addEventListener("change", function(e){
    if(this.checked){
    document.querySelector(".under-cart").querySelector(".check_tooltip").style.display = "none";
  }
  });
    //     window.initHoverLine('.selector-wrapper:not(.cc-swatches) .clickyboxes', {lineCss: { height: '2px' } });
});
  
window.addEventListener("click", function(e){
  //console.log(e.target);
    if(e.target.classList.contains("modal-close")){
    document.querySelector(".cart-drawer").classList.remove("reveal");
    document.querySelector(".cart-drawer").classList.add("unreveal");
    document.querySelector("body").classList.remove("overflow_cart");
  }

    //   if(!e.target.closest("#added-to-cart") || !e.target.classList.contains(".cart-drawer-toggle")){
    //     document.querySelector(".cart-drawer").classList.remove("reveal");
    //     document.querySelector(".cart-drawer").classList.add("unreveal");
    //     document.querySelector("body").classList.remove("overflow_cart");  
    //   }

  return;
});
